// ==================================
// Componente Header
// ==================================

interface HeaderProps {
  titulo: string;
  subtitulo?: string;
  acciones?: React.ReactNode;
}

export function Header({ titulo, subtitulo, acciones }: HeaderProps) {
  return (
    <header className="bg-white border-b border-stone-200/80">
      <div className="px-4 sm:px-6 py-4 sm:py-5">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-xl sm:text-2xl font-display font-bold text-obsidian-900">{titulo}</h1>
            {subtitulo && (
              <p className="mt-1 text-sm text-stone-500">{subtitulo}</p>
            )}
          </div>
          {acciones && (
            <div className="flex items-center gap-3">
              {acciones}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
